var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1500.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6720,14464c-1116-79-2110-388-3025-942C2017,12506,875,10784,595,8848c-51-358-59-475-60-923 c0-429,6-544,46-850c367-2815,2495-5074,5284-5610c458-88,703-110,1230-109c448,0,563,7,925,59c1065,154,2102,580,2968,1222 c61,45,120,83,129,83c10,0,467-448,1028-1009c555-554,1030-1022,1055-1038c69-46,158-89,240-115c64-20,96-23,220-23s156,3,220,23 c226,71,406,223,505,427c66,137,80,196,79,360c0,132-2,146-32,235c-70,205-18,146-1139,1270c-557,559-1013,1023-1013,1032 s43,75,95,147c691,947,1119,2051,1239,3201c98,928-3,1843-299,2735c-120,361-209,575-380,915c-714,1413-1945,2537-3424,3125 c-583,232-1169,373-1821,441C7543,14461,6861,14474,6720,14464z M7500,12829c840-76,1611-344,2299-796c279-183,495-358,740-598 c865-847,1377-1950,1471-3164c5-74,10-237,10-361c0-549-80-1048-250-1560c-304-913-861-1707-1629-2318c-602-480-1368-828-2137-971 c-325-60-557-81-914-81c-445,0-776,39-1189,141c-1415,348-2621,1325-3251,2634c-570,1183-651,2504-232,3745 c491,1452,1640,2596,3097,3085c460,155,869,231,1385,259C7000,12849,7382,12840,7500,12829z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8139f326319da807a6db01c6c525170a.svg";
export { ForwardRef as ReactComponent };